import React from 'react';
import scout from 'images/slideShow/scout.png';

const ScoutOverlay = () => (
  <img
    aria-hidden
    alt=""
    className="tw-absolute tw-right-[5.7%] tw-top-[1%] tw-z-10 tw-w-[6%]"
    data-testid="scout-overlay"
    src={scout}
  />
);

export default ScoutOverlay;
